import BithidePayment from './BithidePayment';
export default BithidePayment;
